import Image from "next/image";
import React from "react";
import checkIcon from "../../public/images/home/check-feature.svg";

const BenefitItem = ({ item }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-5">
      <div style={{ backgroundColor: item.iconColor }} className="benefit-icon">
        <Image src={item.icon.src} width={40} height={40} alt="" />
      </div>
      <div className="flex items-center justify-center gap-3 mt-3">
        <Image src={checkIcon.src} width={25} height={25} alt="" />
        <div className="text-xl font-extrabold">{item.title}</div>
      </div>
      <div className="font-semibold leading-relaxed">{item.description}</div>
    </div>
  );
};

export default BenefitItem;
